import {useNavigate} from "react-router-dom";
import {useLocation} from "react-router-dom";
import pp from "../../assets/img/pp.png";

export default function Badge() {
    const navigate = useNavigate();
    const location = useLocation();
    // Sections with their own sub-brand in the header (the rest use the personal name)
    const sectionBrands = [
        {prefix: "/apps", name: "mpospirit.apps"},
        {prefix: "/designs", name: "mpospirit.makes"},
        {prefix: "/games", name: "mpospirit.games"},
    ];
    const brand = sectionBrands.find(({prefix}) =>
        location.pathname === prefix || location.pathname.startsWith(prefix + "/")
    );

    const ppStyle = {
        width: "72px",
        height: "72px",
        flexShrink: 0,
        cursor: "pointer",
    }
    const nameStyle = {
        fontSize: "1.75rem",
        marginTop: 0,
        marginBottom: 0,
        cursor: "pointer",
    }
    const nicknameStyle = {
        fontStyle: "italic",
        marginTop: "-2px",
        marginBottom: 0,
        cursor: "pointer",
    }

    return (
        <div className="d-flex align-items-center gap-3 text-start">
            <img src={pp} alt="mpospirit" onClick={() => navigate('/')} style={ppStyle}/>
            <div>
                <h1 onClick={() => navigate('/')} style={nameStyle}>
                    {brand ? brand.name : "Çağrı Gökpunar"}
                </h1>
                <p onClick={() => navigate('/')} style={nicknameStyle}>
                    {brand ? "by Çağrı Gökpunar" : "mpospirit"}
                </p>
            </div>
        </div>
    )
}